import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom'

// fabric icons, necessary for things that use icons like check boxes
import { initializeIcons } from '@uifabric/icons';

import './index.css';
import SurveyStart from './survey/SurveyStart';
import SurveyManager from './survey/SurveyManager';
import registerServiceWorker from './registerServiceWorker';

import 'bootstrap/dist/css/bootstrap.min.css';

//if (typeof (window.parent) !== "undefined" && window.parent !== null) {
//    if (typeof (window.parent.appUser) !== "undefined") {
//        //console.log(window.parent.appUser);

//        // Register icons and pull the fonts from the default SharePoint cdn:
//        initializeIcons();

//        ReactDOM.render(<BrowserRouter basename="/Correlator/SurveyManager">
//            <React.Fragment>
//                <Route exact path="/" component={SurveyStart} />
//                <Route path="/survey/edit/:job?/:client?" component={SurveyManager} />
//            </React.Fragment>
//        </BrowserRouter>, document.getElementById('root'));

//        registerServiceWorker();
//    }
//    else {
//        alert("Unable to open Survey Manager. Please log in.");
//    }    
//}
//else {
//    alert("Unable to open Survey Manager. Please log in.");
//}

// Register icons and pull the fonts from the default SharePoint cdn:
initializeIcons();

ReactDOM.render(<BrowserRouter basename="/SurveyManager">
    <React.Fragment>
        <Route exact path="/" component={SurveyStart} />
        <Route path="/survey/edit/:job?/:client?" component={SurveyManager} />
    </React.Fragment>
</BrowserRouter>, document.getElementById('root'));

//registerServiceWorker();


registerServiceWorker();

